import Link from 'next/link'

export default function button({
  children,
  className,
  isLoading = false,
  href = null,
  onClick = null,
  type = 'lg',
  disabled = false,
  ...otherProps
}) {
  const style = {
    lg: 'px-8 py-3 text-lg font-normal tracking-wider border-2 border-orange md:text-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange font-serif text-orange',
    sm: 'px-4 py-1.5 text-base font-normal tracking-wider border-2 border-orange md:text-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange font-serif text-orange',
    outline:
      'block border-2 border-orange bg-transparent px-4 py-2 text-sm font-medium uppercase text-orange w-full text-center',
    plain:
      'block border-2 border-orange bg-orange px-4 py-2 text-sm font-medium uppercase text-white w-full text-center',
    yellow:
      'block bg-yellow-50 px-4 py-2 text-sm font-medium uppercase text-yellow-500 w-full text-center !no-underline',
    'yellow-outline':
      'block border-2 border-yellow-50 bg-transparent px-4 py-2 text-sm font-medium uppercase text-yellow-50 w-full text-center !no-underline'
  }

  if (onClick && !href) {
    return (
      <button
        className={`${style[type]} ${className} ${disabled ? 'opacity-75' : ''}`}
        onClick={(e) => {
          if (isLoading) {
            e.preventDefault()
            return
          }
          onClick()
        }}
        disabled={isLoading || disabled}
        {...otherProps}>
        {isLoading ? (
          <svg
            className="inline-block h-5 w-5 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24">
            <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        ) : (
          <span>{children}</span>
        )}
      </button>
    )
  }

  return (
    <Link href={href}>
      <a className={`${style[type]} ${className} relative`} {...otherProps}>
        {isLoading ? (
          <div className="absolute top-0 left-0 flex h-full w-full items-center justify-center object-cover">
            <svg className="h-5 w-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          </div>
        ) : null}
        <span className={isLoading ? 'text-transparent' : ''}>{children}</span>
      </a>
    </Link>
  )
}
